import { Create, List, DetailCreate, Result, DetailList, DetailEdit } from "../Components/index.js";

export default [
    {
        path: "/training/practice-ret/list",
        component: List,
        name: "training-practice-ret-list",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/training/practice-ret/detail-list",
        component: DetailList,
        name: "training-practice-ret-detail-list",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/training/practice-ret/detail",
        component: DetailCreate,
        name: "training-practice-ret-detail",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/training/practice-ret/detail-edit/:id",
        component: DetailEdit,
        name: "training-practice-ret-detail-edit",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/training/practice-ret/result",
        component: Result,
        name: "training-practice-ret-result",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/training/practice-ret/create",
        component: Create,
        name: "training-practice-ret-create",
        meta: {
            requiresAuth: true,
        },
    },
];
